/**
 * A spec field's description. Some are written by the workbench's connector
 * (MCP settings, the user prompt, site-rule help), not by the agent's own
 * platform: those carry a small "From workbench" note so nobody mistakes them
 * for the agent author's words. No description, nothing shown.
 */

export function SpecDescription({ text, source }: { text: string; source?: string | undefined }) {
  if (!text) return null;
  return (
    <span className="text-xs text-muted">
      {text}
      {source === "workbench" && <span className="ml-1.5 text-[11px] text-faint">From workbench</span>}
    </span>
  );
}
